import React, { useState, useEffect, useContext } from "react";
import "./index.scss";
import { Card, CardContent, Grid } from "@mui/material";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import {
  formatAllInfoResponse,
  formatIndiaMapData,
} from "../../../components/overview/helper";
import Overview1 from "../../../components/overview/overview1";

import IndiaMap from "../../../core/india-map";
import { INDIA_MAP_DATA } from "../../admin/dashboard/helper";
import AppContext from "../../../utils/context";
import { financialYears } from "../../../components/financial-year-calendar/helper";
import CustomBarChart from "../../../components/overview/bar-chart";

const OemHoDashboard = () => {
  const [dashboardDetails, setDashboardDetails] = useState({});
  const [indiaMapData, setIndiaMapData] = useState({ ...INDIA_MAP_DATA });
  const [ticketCounts, setTicketCounts] = useState({});
  const [isCallApis, setIsCallApis] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const { overviewDashboardFilter = {}, setOverviewDashboardFilter } =
    useContext(AppContext);
  const loadStateData = (params = {}) => {
    const payload = {
      ...params,
      ...overviewDashboardFilter,
    };
    loadData(payload);
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.OEM_HO_DASHBOARD_STATE_DATA}`,
      payload
    )
      .then((res) => {
        if (!res.message) {
          const result = res
            ?.map((ele) => ({
              state: ele?._id,
              count: ele?.count,
            }))
            .filter((st) => st.state && st);
          setDashboardDetails((prevVal) => ({
            ...prevVal,
            stateWiseCounts2: result,
          }));
          setIndiaMapData((prevVal) => formatIndiaMapData(result, prevVal));

          // setIndiaMapData((prevVal) =>
          //   formatIndiaMapData(DUMMY_STATE_DATA, prevVal)
          // );
        }
      })
      .catch((err) => console.error(err));
  };
  const loadData = (payload) => {
    const params = { ...payload, ...overviewDashboardFilter };
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.OEM_DASHBOARD}`,
      params
    )
      .then((response) => {
        const formattedData = formatAllInfoResponse(response);
        setDashboardDetails((prevVal) => ({ ...prevVal, ...formattedData }));
      })
      .catch((err) => console.error(err));

    invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.OEM_TICKETS_COUNTS}`, {
      ...payload,
      ...overviewDashboardFilter,
    })
      .then((response) => {
        setTicketCounts(response);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    const storedFilters = JSON.parse(sessionStorage.getItem("overviewFilters"));

    // If filters exist in sessionStorage, load them
    if (storedFilters && storedFilters.length > 0) {
      setSelectedFilters(storedFilters);
    } else {
      // If no filters in sessionStorage, set default filter
      sessionStorage.setItem("overviewFilters", JSON.stringify([]));
      const financialYear = financialYears?.[0];
      const defaultFilters = [
        {
          type: "status",
          value: { label: "Open", value: "OPENED" },
        },
        {
          type: "financialYear",
          value: {
            label: financialYear?.label,
            value: financialYear?.label,
          },
        },
      ];
      setSelectedFilters(defaultFilters);
      setOverviewDashboardFilter({
        status: ["OPENED"],
        financialYear: [financialYear?.label],
      });
      setIsCallApis(true);
    }
  }, []);
  // Save selected filters to sessionStorage whenever they change
  useEffect(() => {
    if (selectedFilters?.length > 0) {
      sessionStorage.setItem(
        "overviewFilters",
        JSON.stringify(selectedFilters)
      );
    }
    return () => {
      if (Object.keys(overviewDashboardFilter)?.length <= 0) {
        sessionStorage.setItem("overviewFilters", JSON.stringify([]));
      }
    };
  }, [selectedFilters]);

  // Effect to update filters when state filter is changed
  useEffect(() => {
    if (overviewDashboardFilter?.state) {
      setSelectedFilters((prevVal) => {
        const existingFilterIndex = prevVal.findIndex(
          (filter) => filter.type === "state"
        );
        if (existingFilterIndex !== -1) {
          const updatedFilters = [...prevVal];
          updatedFilters[existingFilterIndex] = {
            type: "state",
            value: overviewDashboardFilter?.state?.[0],
          };
          return updatedFilters;
        } else {
          return [
            ...prevVal,
            {
              type: "state",
              value: overviewDashboardFilter?.state?.[0],
            },
          ];
        }
      });
    } else {
      setSelectedFilters((prevVal) =>
        prevVal?.filter((filter) => filter.type !== "state")
      );
    }
  }, [overviewDashboardFilter]);
  useEffect(() => {
    if (isCallApis) {
      loadData();
      loadStateData();
    }
  }, [overviewDashboardFilter, isCallApis]);

  return (
    <div className="page-body">
      <div>
        <p className="tab-name">Dashboard</p>
        <p className="section-name">Tickets Overview</p>
      </div>
      <Grid container spacing={2}>
        <Grid item md={6}>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <IndiaMap
                data={indiaMapData}
                title="State wise overview"
                loadStateData={loadStateData}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                isOverview={true}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={6}>
          <Overview1
            dashboardDetails={dashboardDetails}
            ticketCounts={ticketCounts}
            isCallApis={isCallApis}
          />
        </Grid>
      </Grid>
    </div>
  );
};
export default OemHoDashboard;
